// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/infoIconRed.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsCompoMain {
  border-radius: 8px 8px 0 0;
  overflow-y: auto;
  height: 100%;
}
.tabsCompoMain table td:after {
  width: 0;
}
.tabsCompoMain .columnWidth {
  width: 320px;
  background-color: #edf4fa;
}
.tabsCompoMain .accordion {
  margin: 0;
  height: 100%;
}
.tabsCompoMain .accordion .accordion-item {
  height: 100%;
  overflow: hidden;
}
.tabsCompoMain .accordion .accordion-item .accordion-header:has(.collapsed) {
  background-color: rgb(255, 239, 216);
}
.tabsCompoMain .accordion .accordion-item .accordion-header {
  background-color: rgb(214, 236, 255);
  border-radius: 4px 4px 0 0 !important;
}
.tabsCompoMain .accordion.accordion-flush .accordion-collapse {
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;
}
.tabsCompoMain .accordion .accordion-body {
  padding: 0px;
}
.tabsCompoMain .accordion .accordion-button {
  box-shadow: none;
  outline: none;
  padding-left: 30px;
  font-size: 14px;
  color: #003da5;
  background-color: #d6ecff !important;
  width: fit-content;
  margin-right: 2px;
  width: 100%;
  padding: 8px;
}
.tabsCompoMain .accordion .accordion-button::after {
  right: 20px;
  position: absolute;
}
.tabsCompoMain .accordion .accordion-button:not(.collapsed) {
  background: rgb(214, 236, 255);
  color: #003da5;
}
.tabsCompoMain .accordion .collapsed {
  background-color: rgb(255, 239, 216);
}

.p-tabview {
  height: 100%;
}
.p-tabview .p-tabview-nav-content {
  width: 97%;
}
.p-tabview .p-tabview-panel {
  height: 100%;
}
.p-tabview .p-tabview-panel .tabsCompo {
  height: fit-content;
  overflow: hidden;
}
.p-tabview .p-tabview-panel .tabsCompo .form-select {
  max-width: 208px;
  font-size: 12px;
}
.p-tabview .p-tabview-panels {
  padding: 10px;
  height: calc(100% - 80px);
  overflow: auto;
  background-color: white;
  margin-top: 10px;
  border-radius: 10px 10px 0 0;
}

.p-tabview .p-tabview-nav {
  border: 0;
  background-color: transparent;
  gap: 15px;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 10px;
  border-radius: 8px;
  border: 0;
  margin: 0;
  text-decoration: none;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link .p-tabview-title {
  font-size: 12px;
  line-height: 14px;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link .p-tabview-title .custom-tab-header {
  display: flex;
  align-items: center;
  justify-content: center;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link .p-tabview-title button.close-button {
  border: 0;
  padding-left: 10px;
  background: transparent;
  color: inherit;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link button.close-button {
  border: 0;
  padding-left: 10px;
  background: transparent;
  color: inherit;
}
.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #003da5;
  border-color: #003da5;
  color: #fff;
}
.p-tabview .p-tabview-nav .p-tabview-ink-bar {
  display: none;
}

.headerIcon .p-dialog-title {
  display: flex;
}
.headerIcon .p-dialog-title:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  padding: 6px 12px 0 0;
  vertical-align: middle;
}
.headerIcon.p-dialog.actionDialog .p-dialog-content {
  padding-left: 64px !important;
  padding-top: 6px;
}

.bottomSinglebutton .p-dialog-footer {
  text-align: center;
}

.form-select:focus {
  box-shadow: none;
  border-color: #003da5;
}

.btn-right-wrapper {
  display: flex;
  margin: 2px 0px 10px 0px;
  justify-content: flex-end;
}
.btn-right-wrapper .btn-right {
  color: #fff;
  padding: 10px 24px;
  border-radius: 20px;
  background-color: #003da5;
  border: 1px solid #003da5;
}
.btn-right-wrapper .btn-right.greyed-out-btn {
  cursor: not-allowed;
}

.p-tabview-title span {
  display: inline-block;
  padding: 5px;
}
.p-tabview-title span.pmpDes:first-letter {
  margin-right: 7px;
}

.owner-field-form {
  font-size: 12;
}

.tabViewOwner {
  width: 30% !important;
}

.tabViewOwnerDisabled {
  width: 30% !important;
  background-color: rgb(233, 236, 239);
}

.common-owner-field {
  text-align: -webkit-center;
}

.artworkOwnerFieldDisabled {
  background-color: rgb(233, 236, 239);
}

.massOwnerFieldDisabled {
  background-color: rgb(233, 236, 239);
}`, "",{"version":3,"sources":["webpack://./src/components/DSBP/PMPSpecificTabView/index.scss"],"names":[],"mappings":"AAAA;EAEE,0BAAA;EACA,gBAAA;EACA,YAAA;AAAF;AACE;EACE,QAAA;AACJ;AAEE;EACE,YAAA;EACA,yBAAA;AAAJ;AAME;EACE,SAAA;EACA,YAAA;AAJJ;AAKI;EACE,YAAA;EACA,gBAAA;AAHN;AAIM;EACE,oCAAA;AAFR;AAIM;EACE,oCAAA;EACA,qCAAA;AAFR;AAKI;EACE,YAAA;EACA,cAAA;EACA,oBAAA;AAHN;AAKI;EACE,YAAA;AAHN;AAKI;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAHN;AAIM;EACE,WAAA;EACA,kBAAA;AAFR;AAIM;EACE,8BAAA;EACA,cAAA;AAFR;AAKI;EACE,oCAAA;AAHN;;AAOA;EACE,YAAA;AAJF;AAKE;EACE,UAAA;AAHJ;AAKE;EACE,YAAA;AAHJ;AAII;EACE,mBAAA;EAEA,gBAAA;AAHN;AAIM;EACE,gBAAA;EACA,eAAA;AAFR;AAME;EACE,aAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,4BAAA;AAJJ;;AAQA;EACE,SAAA;EACA,6BAAA;EACA,SAAA;AALF;AAOI;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,qBAAA;AALN;AAMM;EACE,eAAA;EACA,iBAAA;AAJR;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAHV;AAKQ;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;AAHV;AAMM;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;AAJR;AAOI;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AALN;AAQE;EACE,aAAA;AANJ;;AAUE;EACE,aAAA;AAPJ;AAQI;EACE,gDAAA;EACA,qBAAA;EACA,sBAAA;AANN;AASE;EACE,6BAAA;EACA,gBAAA;AAPJ;;AAWE;EACE,kBAAA;AARJ;;AAYE;EACE,gBAAA;EACA,qBAAA;AATJ;;AAaA;EACE,aAAA;EACA,wBAAA;EACA,yBAAA;AAVF;AAWE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AATJ;AAUI;EACE,mBAAA;AARN;;AAcE;EACE,qBAAA;EACA,YAAA;AAXJ;AAaI;EACE,iBAAA;AAXN;;AAgBA;EACE,aAAA;AAbF;;AAeA;EACE,qBAAA;AAZF;;AAeA;EACE,qBAAA;EACA,oCAAA;AAZF;;AAcA;EACE,0BAAA;AAXF;;AAaA;EACE,oCAAA;AAVF;;AAaA;EACE,oCAAA;AAVF","sourcesContent":[".tabsCompoMain {\n  // background-color: #eaecea;\n  border-radius: 8px 8px 0 0;\n  overflow-y: auto;\n  height: 100%;\n  table td:after {\n    width: 0;\n  }\n\n  .columnWidth {\n    width: 320px;\n    background-color: #edf4fa;\n  }\n\n  // .accordion .accordion-item .accordion-header:first-child {\n  //   border-radius: 4px 4px 0 0;\n  // }\n  .accordion {\n    margin: 0;\n    height: 100%;\n    .accordion-item {\n      height: 100%;\n      overflow: hidden;\n      .accordion-header:has(.collapsed) {\n        background-color: rgba(255, 239, 216, 1);\n      }\n      .accordion-header {\n        background-color: rgba(214, 236, 255, 1);\n        border-radius: 4px 4px 0 0 !important;\n      }\n    }\n    &.accordion-flush .accordion-collapse {\n      height: 100%;\n      overflow: auto;\n      padding-bottom: 20px;\n    }\n    .accordion-body {\n      padding: 0px;\n    }\n    .accordion-button {\n      box-shadow: none;\n      outline: none;\n      padding-left: 30px;\n      font-size: 14px;\n      color: #003da5;\n      background-color: #d6ecff !important;\n      width: fit-content;\n      margin-right: 2px;\n      width: 100%;\n      padding: 8px;\n      &::after {\n        right: 20px;\n        position: absolute;\n      }\n      &:not(.collapsed) {\n        background: rgba(214, 236, 255, 1);\n        color: #003da5;\n      }\n    }\n    .collapsed {\n      background-color: rgba(255, 239, 216, 1);\n    }\n  }\n}\n.p-tabview {\n  height: 100%;\n  .p-tabview-nav-content {\n    width: 97%;\n  }\n  .p-tabview-panel {\n    height: 100%;\n    .tabsCompo {\n      height: fit-content;\n      //height: 100%;\n      overflow: hidden;\n      .form-select {\n        max-width: 208px;\n        font-size: 12px;\n      }\n    }\n  }\n  .p-tabview-panels {\n    padding: 10px;\n    height: calc(100% - 80px);\n    overflow: auto;\n    background-color: white;\n    margin-top: 10px;\n    border-radius: 10px 10px 0 0;\n  }\n}\n\n.p-tabview .p-tabview-nav {\n  border: 0;\n  background-color: transparent;\n  gap: 15px;\n  li {\n    .p-tabview-nav-link {\n      padding: 10px;\n      border-radius: 8px;\n      border: 0;\n      margin: 0;\n      text-decoration: none;\n      .p-tabview-title {\n        font-size: 12px;\n        line-height: 14px;\n        .custom-tab-header {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        button.close-button {\n          border: 0;\n          padding-left: 10px;\n          background: transparent;\n          color: inherit;\n        }\n      }\n      button.close-button {\n        border: 0;\n        padding-left: 10px;\n        background: transparent;\n        color: inherit;\n      }\n    }\n    &.p-highlight .p-tabview-nav-link {\n      background: #003da5;\n      border-color: #003da5;\n      color: #fff;\n    }\n  }\n  .p-tabview-ink-bar {\n    display: none;\n  }\n}\n.headerIcon {\n  .p-dialog-title {\n    display: flex;\n    &:before {\n      content: url('../../../assets/images/infoIconRed.svg');\n      padding: 6px 12px 0 0;\n      vertical-align: middle;\n    }\n  }\n  &.p-dialog.actionDialog .p-dialog-content {\n    padding-left: 64px !important;\n    padding-top: 6px;\n  }\n}\n.bottomSinglebutton {\n  .p-dialog-footer {\n    text-align: center;\n  }\n}\n.form-select {\n  &:focus {\n    box-shadow: none;\n    border-color: #003da5;\n  }\n}\n\n.btn-right-wrapper {\n  display: flex;\n  margin: 2px 0px 10px 0px;\n  justify-content: flex-end;\n  .btn-right {\n    color: #fff;\n    padding: 10px 24px;\n    border-radius: 20px;\n    background-color: #003da5;\n    border: 1px solid #003da5;\n    &.greyed-out-btn {\n      cursor: not-allowed;\n    }\n  }\n}\n\n.p-tabview-title {\n  span {\n    display: inline-block;\n    padding: 5px;\n\n    &.pmpDes:first-letter {\n      margin-right: 7px;\n    }\n  }\n}\n\n.owner-field-form{\n  font-size: 12\n}\n.tabViewOwner{\n  width: 30% !important;\n}\n\n.tabViewOwnerDisabled{\n  width: 30% !important;\n  background-color: rgb(233, 236, 239);\n}\n.common-owner-field{\n  text-align: -webkit-center;\n}\n.artworkOwnerFieldDisabled{\n  background-color: rgb(233, 236, 239);\n  // width: 80% !important;\n}\n.massOwnerFieldDisabled{\n  background-color: rgb(233, 236, 239);\n  // width: 232px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
